var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiBangkeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_375_19147)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.30997,
    cy: 9.30997,
    r: 1.55167,
    fill: "#B8ADAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.30997 9.30997L17.0683 1.55164M13.965 9.30997C13.965 11.8809 11.8809 13.965 9.30997 13.965C6.73908 13.965 4.65497 11.8809 4.65497 9.30997C4.65497 6.73908 6.73908 4.65497 9.30997 4.65497C11.8809 4.65497 13.965 6.73908 13.965 9.30997ZM17.0683 9.30997C17.0683 13.5948 13.5948 17.0683 9.30997 17.0683C5.02516 17.0683 1.55164 13.5948 1.55164 9.30997C1.55164 5.02516 5.02516 1.55164 9.30997 1.55164C13.5948 1.55164 17.0683 5.02516 17.0683 9.30997Z",
    stroke: "#B8ADAF",
    strokeWidth: 1.29661,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_375_19147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.62,
    height: 18.62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiBangkeo);
export default __webpack_public_path__ + "static/media/mi-bangkeo.ea07446f44c5baca4bac7fb9e5983492.svg";
export { ForwardRef as ReactComponent };